<template>
  <div id="cashflow">
      <div v-if="chartData.length">
        <h1 align="center">Cash Flow</h1>

        <select v-model="date" @change="updateChart()" class="selectbox">
          <option disabled value="">Please select one</option>
          <option v-for="(item,key) in data" :key=key>
            {{key}}
          </option>
        </select>
        <br>
      <dx-chart
          id="chart"
          :data-source="chartData"
      >
          <dx-argument-axis>
            <dx-label
              overlapping-behavior="stagger"
            />
          </dx-argument-axis>

          <dx-series
          argument-field="key"
          value-field="value"
          name="USD"
          type="bar"
          color="#27cf97"
          />
      </dx-chart>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
// import VueApexCharts from 'vue-apexcharts';
// import { ChartSankey } from 'vue-d2b';
import
{
  DxChart, 
  DxSeries,
  DxLabel,
  DxArgumentAxis,
} 
from 'devextreme-vue/chart';


export default {
  name: 'CashFlowComponent',
  components:{
    DxChart, 
    DxSeries,
    DxLabel,
    DxArgumentAxis,
  },
  props:['ticker'],
  data() {
    return {
    //   ticker: this.mainTicker,
      data: null,
      selectedData: null,
      date: null,
      chartData:[],
    }
  },
  // computed: {},
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
        if (!this.ticker){
            return
        }
        var params = {
            'ticker':this.ticker,
        }
        await axios
            // .get('http://127.0.0.1:5000/api/cashflow', {params:params})
            .get('https://ue97gtatpe.execute-api.us-west-1.amazonaws.com/dev/api/cashflow', {params:params})
            .then(response => {
                this.data = response.data['data']
                var keys = Object.keys(this.data)
                this.date = keys[keys.length-1]
                this.selectedData = this.data[this.date]
                this.updateChart()
            })
            .catch(e => {
                e
            })
    },
    updateChart() {
      this.selectedData = this.data[this.date]
      let chartData = []
        Object.keys(this.selectedData).forEach((obKey) => {
            chartData.push({key:obKey,value:this.selectedData[obKey]})
        })
        this.chartData = chartData
    },
    customizeLinkTooltip(info) {
      return {
        html: `<b>From:</b> ${info.source}<br/><b>To:</b> ${info.target}<br/><b>Weight:</b> ${info.weight}`
      };
    },
  },
  watch: {
      ticker: function(){
          this.fetchData()
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.selectbox{
  border:1px solid #BBBBBB;
  border-radius: 5px;
  border-color:#BBBBBB;
  /* height:100%; */
}

</style>